<script setup>
import Grid from "@/components/Grid.vue";

const props = defineProps(['columns', 'items', 'gridParams', 'gridMethods', 'gridAction']);

function action() {
    if (props.gridAction) {
        props.gridAction(...arguments);
    }
}
</script>

<template>
    <Grid
        :columns="columns"
        :data="items"
        has-filters
        :page-length="parseInt(gridParams.pageLength)"
        :total-rows-count="gridParams.totalRowsCount"
        :sort="gridParams.sort"
        :currentPage="gridParams.currentPage"
        @changePage="gridMethods.changePage"
        @changeFilters="gridMethods.setFilters"
        @changeSort="gridMethods.changeSort"
        @action="action"
    />
</template>

<style scoped>

</style>
